export function splitString(
  stringToSplit: string,
  separator: string
): string[] {
  const arrayOfStrings = stringToSplit.split(separator);
  return arrayOfStrings;
}
